<script lang="ts" setup>import { computed as _computed } from 'vue';

withDefaults(defineProps<{ content: string }>(), {  })

const [MarkdownIt, attrs] = await Promise.all([
  import('markdown-it').then(({ default: mod }) => mod),
  import('markdown-it-attrs').then(({ default: mod }) => mod),
])

const md = new MarkdownIt().use(attrs).set({ html: true, linkify: true })
const defaultRender = md.renderer.rules.link_open || function (tokens, idx, options, env, self) {
  return self.renderToken(tokens, idx, options)
}

md.renderer.rules.link_open = function (tokens, idx, options, env, self) {
  // Add a new `target` attribute, or replace the value of the existing one.
  tokens[idx].attrSet('target', '_blank')

  // Pass the token to the default renderer.
  return defaultRender(tokens, idx, options, env, self)
}

const renderedMarkdown = _computed(() => md.render(__props.content))
</script>

<template>
  <div class="markdown" v-html="renderedMarkdown"/>
</template>

<style scoped lang="scss">
:deep(a) {
  font-weight: 600;
}

:deep(p) {
  word-break: break-word;
}

:deep(ol) {
  list-style: decimal;
  margin-bottom: 0.5rem;
  margin-left: 1.5rem;
  margin-top: 0.5rem;
}

:deep(ul) {
  list-style: disc;
  margin-bottom: 0.5rem;
  margin-left: 1.5rem;
  margin-top: 0.5rem;
}

:deep(li) {
  margin-bottom: 0.25rem;
}
</style>
